import { inject, Injector, runInInjectionContext } from "@angular/core"
import { Router } from "@angular/router"
import { ToastrService } from "ngx-toastr"
import { routes } from "src/app/consts"

import { AuthService } from "~services/auth.service"
import { DbService } from "~services/db.service"

export const authGuard = (authType = "admin") =>
  // _state: RouterStateSnapshot,
  // route: ActivatedRouteSnapshot
  {
    let lastToastTime = 0
    return new Promise<boolean>((resolve) => {
      const injector = inject(Injector)
      const router = inject(Router)
      const authService = inject(AuthService)
      const toastr = inject(ToastrService)
      const dbService = inject(DbService)

      if (router.url === routes.LOGIN) {
        resolve(true)
        return
      }

      let lastUid = ""
      // let haveFailed = false
      // const attemptedUrl = route.url

      const fail = async (user?: unknown) => {
        // haveFailed = true
        if (user) {
          await authService.logout(false)
        }

        if (Date.now() - lastToastTime > 5000) {
          console.log("fail", router.url)
          toastr.error("You are not authorized to access this page", "Error")
          lastToastTime = Date.now()
          await router.navigate([routes.LOGIN])
        }
        resolve(false)
      }

      authService.user$.subscribe(async (user) => {
        if (user) {
          if (user.uid !== lastUid) {
            lastUid = user.uid

            runInInjectionContext(injector, () => {
              console.log("runInInjectionContext, checking for permissions")
              dbService
                .getItemSnapshot(`${authType}s`, user.uid)
                .then(async () => {
                  // if (haveFailed) {
                  // INSERT_YOUR_CODE
                  if (router.url === routes.LOGIN) {
                    await router.navigate([routes.QUIZ_EVENTS])
                  }
                  // } else {
                  resolve(true)
                  // }
                })
                .catch(async () => {
                  await fail(user)
                })
            })
          }
        } else {
          await fail()
        }
      })
    })
  }
